import React from 'react';
import Logo from '../Logo';
import HeaderMenu from '../HeaderMenu';

import classes from './styles.module.css';

export default function Header({ menuConfig, showMenu = true }) {
    const brand = [{ bgColor: '' }, { copyText: '' }];

    switch (process.env.BRAND) {
        case 'wl':
            brand.bgColor = '#273246';
            break;
        case 'unlimco':
            brand.bgColor = '#273246';
            break;
        case 'eclear':
            brand.bgColor = '#074076';
            break;
        default:
            brand.bgColor = '#273246';
    }

    return (
        <React.Fragment>
            <header className={classes.Header} style={{ backgroundColor: brand.bgColor }}>
                <div className={classes.Container}>
                    <Logo style={{ width: '180px', height: '35px', margin: '8px 0', top: '0' }} />
                    {showMenu && <HeaderMenu menuConfig={menuConfig} mode="top" />}
                </div>
            </header>

            {showMenu && (
                <div className={classes.MenuRow}>
                    <div className={classes.Container}>
                        <HeaderMenu menuConfig={menuConfig} mode="nav" />
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/Components/Header/index.js